import React, { useContext } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../videosAssignmentState/videosAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import classNames from 'classnames';
import style from './SearchFields.module.scss';

const SearchFields: React.FC = () => {
	const {
		changeSearchStringForAllCustomers,
		changeSearchStringForRestaurants,
		changeSearchStringForVideos,
		searchStringForAllCustomers,
		searchStringForRestaurants,
		searchStringForVideos,
		activeItemToDisplay,
	} = useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	const customerSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'customers',
	});
	const restaurantSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'restaurants',
	});
	const videosSearchFieldWrapperClasses = classNames(style.searchFieldWrapper, {
		[style.hide]: activeItemToDisplay !== 'videos',
	});

	return (
		<div className={style.container}>
			<div className={customerSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForAllCustomers}
					searchString={searchStringForAllCustomers}
				/>
			</div>
			<div className={restaurantSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForRestaurants}
					searchString={searchStringForRestaurants}
				/>
			</div>
			<div className={videosSearchFieldWrapperClasses}>
				<SearchField
					onChangeSelectSearchString={changeSearchStringForVideos}
					searchString={searchStringForVideos}
				/>
			</div>
		</div>
	);
};

export default SearchFields;
